import { ReturnPolicySnapshotSettingsSchema } from "@redotech/redo-return-core-common/return-policy/snapshot-settings";
import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** Saves and publishes the settings, and makes the policy the team's live one. */
export const publishReturnPolicy = {
  name: "publishReturnPolicy" as const,
  input: z.object({
    id: returnPolicyIdFormat.schema,
    settings: ReturnPolicySnapshotSettingsSchema,
    changeSummary: z.string().nullable(),
  }),
  output: z.object({ publishedAt: z.date() }),
};
